export const random = (min, max) =>
  Math.floor(Math.random() * (max - min)) + min;

export const cround = (num) =>
  Math.round((Number.parseFloat(num) + Number.EPSILON) * 100) / 100;
